import axios from "axios";
import LocalStorage from "./LocalStorage";

class AxiosInstance {
  static Celestine = () => {
    let value = LocalStorage.AUTH_TOKEN;
    return axios.create({
      baseURL: process.env.REACT_APP_CELESTINE_API_BASE_URL,
      headers: {
        Authorization: `Bearer ${value}`,
        version: "23.6",
      },
    });
  };

  static Dicket = () => {
    let value = LocalStorage.AUTH_TOKEN;
    return axios.create({
      baseURL: process.env.REACT_APP_DICKET_API_BASE_URL,
      headers: {
        Authorization: `Bearer ${value}`,
      },
    });
  };

  static Mercury = () => {
    let value = LocalStorage.AUTH_TOKEN;
    return axios.create({
      baseURL: process.env.REACT_APP_MERCURY_API_BASE_URL,
      headers: {
        Authorization: `Bearer ${value}`,
      },
    });
  };
}

export default AxiosInstance;
